'use client';

import React from 'react';
import { cn } from '@/utils';
import { Button } from '@/components/Buttons/Button';
import { Switch } from '@/components/Fields/Switch';

export interface VideoAudioSwitchProps {
  isSmUp: boolean;
  isVideoEnabled: boolean;
  isDegraded: boolean;
  /** Called with whether the "video" mode was selected. */
  onModeChange: (videoSelected: boolean) => void;
  /** Exit the simulation. */
  onExit: () => void;
}

/**
 * Video/audio mode selector (desktop Switch, mobile icon button) plus an exit
 * action. When degraded, the video option becomes "Try video again".
 */
export const VideoAudioSwitch: React.FC<VideoAudioSwitchProps> = ({
  isSmUp,
  isVideoEnabled,
  isDegraded,
  onModeChange,
  onExit,
}) => (
  <div
    className={cn('flex items-center justify-center gap-2 sm:gap-6', {
      'fixed bottom-auto left-auto right-1 top-1 z-20 justify-end': !isSmUp,
    })}
  >
    {isSmUp ? (
      <Switch
        options={[
          { value: 'video', label: isDegraded ? 'Try video again' : 'Video on' },
          { value: 'audio', label: 'Audio only' },
        ]}
        value={isVideoEnabled ? 'video' : 'audio'}
        onChange={(mode) => onModeChange(mode === 'video')}
      />
    ) : (
      <Button
        iconOnly={true}
        onClick={() => onModeChange(!isVideoEnabled)}
        size="small"
        variant="secondary"
        iconLeft="VideoCamera"
        label={isDegraded ? 'Try video again' : 'Video on'}
        className="bg-white/50 ring-white/30 ring-1 text-neutral-black"
      />
    )}
    <Button
      iconOnly={isSmUp ? false : true}
      label="Exit"
      onClick={onExit}
      size={isSmUp ? 'medium' : 'small'}
      variant="secondary"
      iconLeft={isSmUp ? undefined : 'X'}
      className={isSmUp ? '' : 'bg-white/50 ring-white/30 ring-1 text-neutral-black'}
    />
  </div>
);
